import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { GameTextUtil } from "../../../utils/GameTextUtil";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
/**
 * Game-specific properties for the spins remaining display.
 */
export class GameSpinsRemainingProperties extends ViewProperties {
    constructor() {
        super();
        this.counterSpineProperties = new SpineProperties(GameStyle.SPINS_COUNTER_ANIMATION, GameStyle.MODULE);
        this.spinsValueProperties = new TextFieldProperties(GameFontStyle.STANDARD_SPINS_REMAINING, new Point(0, 0), null, null, null, new Point(50, 40));
        this.spinsLabelProperties = new TextFieldProperties(GameFontStyle.STANDARD_SPINS_REMAINING_LABEL, new Point(0, -30), GameLang.SPINS, null, null, new Point(310, 60));
        this.purchaseSpinsValueProperties = new TextFieldProperties(GameFontStyle.PURCHASE_SPINS_REMAINING, new Point(0, 0), null, null, null, new Point(50, 40));
        this.purchaseSpinsLabelProperties = new TextFieldProperties(GameFontStyle.PURCHASE_SPINS_REMAINING_LABEL, new Point(0, -30), GameLang.SPINS, null, null, new Point(310, 60));
        GameTextUtil.centerProperties(this.spinsValueProperties, this.purchaseSpinsValueProperties);
    }
}
//# sourceMappingURL=GameSpinsRemainingProperties.js.map